import de from "vuetify/es5/locale/de";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
//IE11/Safari9 Support
import '@babel/polyfill'

window.Vue = require('vue');

import Lang from 'lang.js'
import messages from './messages'

const lang = new Lang({messages});
const _ = require('lodash');
const moment = require('moment');

Object.defineProperty(Vue.prototype, '_', {value: _});
Object.defineProperty(Vue.prototype, '$moment', {value: moment});
Object.defineProperty(Vue.prototype, '__', {
    value: (key, replacements) => {
        return lang.get(key, replacements)
    }
});

import Vuetify from 'vuetify'

Vue.use(Vuetify, {
    theme:
        {
            primary: process.env.MIX_COLOR_PRIMARY,
            secondary: process.env.MIX_COLOR_SECONDARY,
            accent: process.env.MIX_COLOR_ACCENT,
        },
    lang: {
        locales: {de},
        current: 'de'
    }
});

window.Vuex = require('vuex');

import VueCurrencyInput from 'vue-currency-input'

Vue.use(VueCurrencyInput, {});

import Validation from './components/plugins/Validation.js';

Vue.use(Validation);

import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

VueCookies.config('5y'); //persistent cookies


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.cos-selectntext('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('s-text-field', require('./components/TextField.vue').default);
Vue.component('s-switch', require('./components/Switch.vue').default);
Vue.component('s-textarea', require('./components/TextArea.vue').default);
Vue.component('s-number-field', require('./components/NumberField.vue').default);
Vue.component('s-price-field', require('./components/PriceField.vue').default);
Vue.component('s-select', require('./components/Select.vue').default);
Vue.component('s-multi-select', require('./components/MultiSelect.vue').default);
Vue.component('s-dropzone', require('./components/Dropzone.vue').default);
Vue.component('s-email-field', require('./components/EmailField.vue').default);
Vue.component('success-snackbar', require('./components/SuccessSnackbar.vue').default);
Vue.component('failure-snackbar', require('./components/FailureSnackbar.vue').default);
Vue.component('s-date-picker', require('./components/DatePicker.vue').default);
Vue.component('s-date-range-picker', require('./components/DateRangePicker.vue').default);

Vue.use(Vuex);
